module.exports = __webpack_public_path__ + "img/PUSDIKLAT.13a41fed.png";